import { ViewModel,View } from "binder"
import  { TranslatorEditorView } from "./translatorEditor-view"
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { TranslatorSelectionPopupViewModel } from "./translatorSelectionPopup/translatorSelectionPopup-viewModel";

export class TranslatorEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId;} private _processId: string;
    public set processName(v: string) { this._processName = v; } public get processName(): string { return this._processName;} private _processName: string;
    public set enumName(v: string) { this._enumName = v; } public get enumName(): string { return this._enumName;} private _enumName: string;
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
    

    async edit(){
        let editor = new TranslatorSelectionPopupViewModel(this);
        await editor.loadData();
        editor.loadInfo(this.value);
        let result =await this.requestShowingPopup(editor); 
        if(result!=null){
            this.value = result;
            this.requestConfirm();
        }
    }
    setValue(v: string) {
        if(stringIsNullOrEmpty(v)){
            this.processId = '';
            this.processName = '';
            this.enumName = '';
        }else{
            let parsed = JSON.parse(v);
            this.processId = parsed.processId;
            this.processName = parsed.processName;
            this.enumName = parsed.enumName;
        }
    }
    getValue(): string {
        return this.value;
    }
    requestConfirm() {
    }
    GetDefaultView(): View <ViewModel> {
        return new TranslatorEditorView();
    }
    public getTypeId(): string {
        return "VM-0E09D656-6DAE-49C2-8EB0-69225905228E"
    }
}
